import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsTreemap from 'highcharts/modules/treemap';
import HighchartsHeatmap from 'highcharts/modules/heatmap';
import { getTreeMapOptions } from './config';
import './Treemap.scss';
HighchartsHeatmap(Highcharts);
HighchartsTreemap(Highcharts);
export const Treemap = ({ chartProps, chartData, chartLevels, customOptions, }) => (React.createElement("div", { className: "treemap-wrapper" },
    React.createElement(HighchartsReact, { highcharts: Highcharts, options: getTreeMapOptions(chartProps, chartData, chartLevels, customOptions) })));
//# sourceMappingURL=Treemap.js.map